import { render } from "./BoardView.vue?vue&type=template&id=f12e0c36&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"

import "./BoardView.vue?vue&type=style&index=0&id=f12e0c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12e0c36"]])

export default __exports__